import { Action, Reducer } from 'redux';
import {
  LoginState,
  LoginKnownAction,
  LOGIN_USER_LOGIN_REQUEST,
  LOGIN_USER_LOGIN_REQUEST_FAIL,
  LOGIN_USER_LOGIN_REQUEST_SUCCESS,
} from './type';

const initialState: LoginState = {
  loginProgress: false,
  loginSuccess: false,
};

const reducer: Reducer<LoginState, LoginKnownAction> = (
  currentState: LoginState | undefined = initialState,
  incomingAction: Action,
) => {
  const action = incomingAction as LoginKnownAction;
  switch (action.type) {
    case LOGIN_USER_LOGIN_REQUEST:
      return {
        loginSuccess: false,
        loginProgress: true,
      };
    case LOGIN_USER_LOGIN_REQUEST_FAIL:
      return {
        loginSuccess: false,
        loginProgress: false,
        error: action.error,
      };

    case LOGIN_USER_LOGIN_REQUEST_SUCCESS:
      return {
        loginSuccess: true,
        loginProgress: false,
        error: undefined,
      };
    default:
      return currentState;
  }
};

export default reducer;
